import { Grid } from '@mui/material';
import { LuSettings2 } from 'react-icons/lu';
import {
  WsButton,
  WsColors,
  WsDialog,
  WsDialogSize,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

export interface SwitchDialogProps {
  title: string;
  body: string;
  switchIcon?: boolean;
  open: boolean;
  onClose: () => void;
  onSave: () => void;
}

export const SwitchDialog = ({
  open,
  onClose,
  switchIcon = false,
  title,
  body,
  onSave,
}: SwitchDialogProps) => (
  <WsDialog openDialog={open} size={WsDialogSize.EXTRASMALL}>
    <Grid container spacing={1} justifyContent="flex-start" alignItems="center" p={2}>
      <Grid item xs={12}>
        <Grid container alignItems="center" columnGap={1}>
          {switchIcon && (
            <Grid item>
              <LuSettings2 size={16} />
            </Grid>
          )}
          <Grid item>
            <WsTypography variant={WsTypoVariants.BODY1} bold>
              {title}
            </WsTypography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <WsTypography variant={WsTypoVariants.BODY2} color={WsColors.TertiaryShades900}>
          {body}
        </WsTypography>
      </Grid>
    </Grid>
    <Grid container justifyContent="center" alignItems="center" columnGap={2} pb={2}>
      <Grid item>
        <WsButton variant="outlined" onClick={onClose}>
          Cancel
        </WsButton>
      </Grid>
      <Grid item>
        <WsButton variant="contained" onClick={onSave}>
          Confirm
        </WsButton>
      </Grid>
    </Grid>
  </WsDialog>
);
